
/*
    Form for editing a TTS message record
    - it's just a long series of checkboxes
*/

import React from "react";

import DataItem from "../Components/DataItem";
import StyledCheckbox from "../Components/StyledCheckbox";

export default class MessagesTTSForm extends React.Component {

    flipValue = (name) => {
        this.props.updateCheck(this.props.index, name);
    }

    /*
    I_ALL: true,
    O_ALL: true,
    I_NM: true,
    I_NB: false,
    I_DEL: false,
    I_LGCH: true,
    I_CAN: true,
    I_RON: true,
    I_ROFF: true,
    I_ROFFTTS: false,
    O_NM: true,
    O_NB: false,
    O_DEL: false,
    O_LGCH: true,
    O_CAN: false,
    O_RON: false,
    O_ROFF: true,
    O_ROFFTTS: false
    */

    render(){
        return (
            <div className="data data-expanded">
                <div className="form-element" style={{
                    display: "flex",
                    justifyContent: "space-around",
                    alignItems: "center"
                }}>
                    <div><DataItem val={this.props.location} /></div>
                    <div><DataItem val={this.props.code} /></div>
                </div>
                <div className="form-element" style={{
                    display: "grid",
                    gridTemplateColumns: "1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr",
                    gridGap: "8px",
                    justifyItems: "flex-start",
                    paddingLeft: "8px"
                }}>
                    <StyledCheckbox 
                        name="I_ALL"
                        label="All I"
                        checked={this.props.I_ALL}
                        onChange={() => this.flipValue("I_ALL")}
                    />
                    <StyledCheckbox 
                        name="I_NM"
                        label="I NM"
                        checked={this.props.I_NM}
                        onChange={() => this.flipValue("I_NM")}
                    />
                    <StyledCheckbox 
                        name="I_NB"
                        label="I NB"
                        checked={this.props.I_NB}
                        onChange={() => this.flipValue("I_NB")}
                    />
                    <StyledCheckbox 
                        name="I_DEL"
                        label="I DEL"
                        checked={this.props.I_DEL}
                        onChange={() => this.flipValue("I_DEL")}
                    />
                    <StyledCheckbox 
                        name="I_LGCH"
                        label="I LGCH"
                        checked={this.props.I_LGCH}
                        onChange={() => this.flipValue("I_LGCH")}
                    />
                    <StyledCheckbox 
                        name="I_CAN"
                        label="I CAN"
                        checked={this.props.I_CAN}
                        onChange={() => this.flipValue("I_CAN")}
                    />
                    <StyledCheckbox 
                        name="I_RON"
                        label="I RON"
                        checked={this.props.I_RON}
                        onChange={() => this.flipValue("I_RON")}
                    />
                    <StyledCheckbox 
                        name="I_ROFF"
                        label="I ROFF"
                        checked={this.props.I_ROFF}
                        onChange={() => this.flipValue("I_ROFF")}
                    />
                    <StyledCheckbox 
                        name="I_ROFFTTS"
                        label="I_ROFFTTS"
                        checked={this.props.I_ROFFTTS}
                        onChange={() => this.flipValue("I_ROFFTTS")}
                    />
                    {
                        /*

                        */
                    }
                    <StyledCheckbox 
                        name="O_ALL"
                        label="All O"
                        checked={this.props.O_ALL}
                        onChange={() => this.flipValue("O_ALL")}
                    />
                    <StyledCheckbox 
                        name="O_NM"
                        label="O NM"
                        checked={this.props.O_NM}
                        onChange={() => this.flipValue("O_NM")}
                    />
                    <StyledCheckbox 
                        name="O_NB"
                        label="O NB"
                        checked={this.props.O_NB}
                        onChange={() => this.flipValue("O_NB")}
                    />
                    <StyledCheckbox 
                        name="O_DEL"
                        label="O DEL"
                        checked={this.props.O_DEL}
                        onChange={() => this.flipValue("O_DEL")}
                    />
                    <StyledCheckbox 
                        name="O_LGCH"
                        label="O LGCH"
                        checked={this.props.O_LGCH}
                        onChange={() => this.flipValue("O_LGCH")}
                    />
                    <StyledCheckbox 
                        name="O_CAN"
                        label="O CAN"
                        checked={this.props.O_CAN}
                        onChange={() => this.flipValue("O_CAN")}
                    />
                    <StyledCheckbox 
                        name="O_RON"
                        label="O RON"
                        checked={this.props.O_RON}
                        onChange={() => this.flipValue("O_RON")}
                    />
                    <StyledCheckbox 
                        name="O_ROFF"
                        label="O ROFF"
                        checked={this.props.O_ROFF}
                        onChange={() => this.flipValue("O_ROFF")}
                    />
                    <StyledCheckbox 
                        name="O_ROFFTTS"
                        label="O ROFFTTS"
                        checked={this.props.O_ROFFTTS}
                        onChange={() => this.flipValue("O_ROFFTTS")}
                    />
                </div>
            </div>
        )
    }
}